export const isObserverValid = (observer) => {
    for (let vid in observer.errors) {
        try {
            if (observer.errors[vid].length) return false;
        } catch (e) {
        }
    }
    return true;
};
